import React, { useContext, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { TablePagination, List, ListItem, ListItemButton, ListItemText, IconButton, Collapse, Grid, Typography } from '@mui/material';
import { customerTicketsContext } from '../../CustomerTicketsContext';
import { CircleLoader } from 'components';
import { useHistory } from 'react-router-dom';
import { customerApplicationContext } from 'helpers/services';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import { localeContext } from 'helpers/Locale/LocaleManager';
import { MdExpandLess as ExpandLess, MdExpandMore as ExpandMore } from 'react-icons/md';


let Results = () => {
    let history = useHistory();
    let { formatMessage } = useIntl();

    let { currentLocale } = useContext(localeContext);
    let { getCategoryById, getSubCategoryById } = useContext(customerApplicationContext);

    let service = useContext(customerTicketsContext);

    let [openItem, setOpenItem] = useState<string | null>(null);

    return <>
        {service.isLoading && <CircleLoader />}
        {service.isLoading === false &&
            <>
                <PerfectScrollbar>
                    <List>
                        {service.tickets.map((ticket, index) =>
                            <React.Fragment key={index}>
                                <ListItemButton
                                    disableGutters
                                    divider={openItem !== ticket.ticketId}
                                    onClick={() => { history.push(`/customer/ticket/edit/${ticket.number}`); }}
                                >
                                    <ListItemText primary={ticket.number} secondary={ticket.title} />
                                    <IconButton
                                        onClick={(event: any) => {
                                            event.stopPropagation();
                                            if (openItem === ticket.ticketId) {
                                                setOpenItem(null);
                                            } else {
                                                setOpenItem(ticket.ticketId);
                                            }
                                        }}
                                        size="large">
                                        {openItem === ticket.ticketId
                                            ? <ExpandLess size={24} />
                                            : <ExpandMore size={24} />
                                        }
                                    </IconButton>
                                </ListItemButton>
                                <Collapse in={(openItem === ticket.ticketId)} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        <ListItem divider onClick={() => { history.push(`/customer/ticket/edit/${ticket.number}`); }}>
                                            <Grid container>
                                                <Grid item xs={12}>
                                                    <Typography variant="body2"><b>{formatMessage({ id: LocalizationIds.Priority })}:</b></Typography>
                                                    {ticket.ticketPriority}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant="body2"><b>{formatMessage({ id: LocalizationIds.Status })}:</b></Typography>
                                                    {ticket.ticketStatus[currentLocale]}
                                                    <div style={{ color: getCategoryById(ticket.categoryId)?.color ?? undefined }}>
                                                        {`${getCategoryById(ticket.categoryId)?.names[currentLocale]} / ${getSubCategoryById(ticket.ticketSubCategoryId)?.names[currentLocale]}`}
                                                    </div>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant="body2"><b>{formatMessage({ id: LocalizationIds.AssignedTo })}:</b></Typography>
                                                    {ticket.assigneeUser != null ?
                                                        <> {ticket.assigneeUser} </>
                                                        : <> {formatMessage({ id: LocalizationIds.NotAssigned })} </>
                                                    }
                                                </Grid>
                                            </Grid>
                                        </ListItem>
                                    </List>
                                </Collapse>
                            </React.Fragment>
                        )}
                        {service.isLoading === false && service.tickets.length === 0 &&
                            <ListItem>
                                <ListItemText primary={formatMessage({ id: LocalizationIds.NoDataFound })} />
                            </ListItem>
                        }
                    </List>
                </PerfectScrollbar>
                <TablePagination
                    component="div"
                    count={service.recordCount}
                    onPageChange={service.handleChangePage}
                    page={service.search.pageNr}
                    rowsPerPage={service.search.pageSize}
                    rowsPerPageOptions={[service.search.pageSize]}
                    labelDisplayedRows={({ page, count }) =>
                        <>
                            {formatMessage({ id: LocalizationIds.TotalTickets })}:&nbsp;{service.recordCount} &nbsp;&middot;&nbsp;
                            {formatMessage(
                                { id: LocalizationIds.PageOf },
                                { pageNr: page + 1, count: Math.ceil(count / service.search.pageSize) }
                            )}
                        </>
                    }
                />
            </>
        }
    </>;
}

export default Results;